import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {setLoader} from '../store/builder/reducer';

const useLoader = loadingStates => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (loadingStates?.some(isLoading => isLoading)) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
  }, [...loadingStates, dispatch]);
};

export default useLoader;
